<template>
    <PreLoginForm :logo="false" title="">
        <div class="nova-header mb-2">
            <img src="@/assets/img/novakid_logos.png" />
        </div>
        <div class="pre-login-title">{{ $t('STEP_FINISHED_TITLE') }}</div>
        <div v-html="subtitle" />
        <div class="pre-login-title mt-5 mb-2 is-size-4">
            {{ $t('NOVAKID_INSTRUCTION_TITLE') }}
        </div>
        <div class="pb-2">
            <div
                v-linkified
                v-for="step in instrucion"
                :key="step"
                v-html="$t(step)"
                class="mb-4"
            />
        </div>
    </PreLoginForm>
</template>
<script>
import PreLoginForm from '@/views/PreLoginView/PreLoginForm'
export default {
    components: { PreLoginForm },
    computed: {
        date() {
            const { lesson_date, lesson_hour } = this.$route.query
            return `${this.$moment(lesson_date).format(
                'D MMMM'
            )} ${this.$moment(lesson_hour).format('HH:mm')}`
        },
        instrucion() {
            const step1 = this.$t('NOVAKID_INSTRUCTION_STEP_1').replace(
                '{novakid}',
                '<span style="color: #17acff">www.novakid.pl</span>'
            )
            return [
                step1,
                'NOVAKID_INSTRUCTION_STEP_2',
                'NOVAKID_INSTRUCTION_STEP_3',
                'NOVAKID_INSTRUCTION_STEP_4'
            ]
        },
        subtitle() {
            const date = `<span style="color: #17acff">${this.date}</span>`
            return this.$t('NOVAKID_LESSON_BOOKED').replace('{date}', date)
        }
    }
}
</script>
<style lang="scss" scoped>
div {
    font-family: $input-family;
}
</style>
